import { Loading } from 'components/loading'
import { RasaContext } from 'context'
import * as GenericRedux from 'generic/genericRedux'
import { RasaReactComponent } from 'generic/rasaReactComponent'
import React from 'react'
import * as Redux from 'redux'
import { SharedKeys, SharedStore } from 'shared/data-layer/sharedStore'
import { injectReducer } from 'store/index'
import { PreviewWidgetMenuComponent } from '../previewMenuWidget'
import '../styles.css'
import { MenuSection } from '../types'
import {
  MenuItems,
  MenuSections,
  REDUX_STORE_HOME,
} from './constants'
import { HeaderSettings } from './layouts/headerSettings'
import { AppearanceSettings } from './layouts/appearanceSettings'
import { ResultsSettings } from './layouts/resultsSettings'
import { PreviewSettings } from './layouts/previewSettings'
import { PreviewComponent } from './preview'
import './style.scss'

type WidgetsSurveyResultsComponentProps = GenericRedux.AllComponentProps<any>
interface WidgetsSurveyResultsComponentState {
  communityId: string,
  communityRecordId: string,
  communityGuid: string,
  configurations: any,
  context?: any,
  selected: MenuSection,
}

class WidgetsSurveyResultsComponent extends RasaReactComponent<WidgetsSurveyResultsComponentProps,
      WidgetsSurveyResultsComponentState> {
  public static contextType = RasaContext
  private sharedStore: SharedStore

  constructor(props: WidgetsSurveyResultsComponentProps) {
    super(props, 'widgetsLayout', {
      communityId: '',
      communityRecordId: '',
      communityGuid: '',
      selected: null,
      configurations: null,
    })
  }

  public componentDidMount = () => {
    this.sharedStore = SharedStore.instance(this.context)
    Promise.all([
      this.sharedStore.getValue(SharedKeys.activeCommunity),
      this.sharedStore.getValue(SharedKeys.hash),
    ])
    .then(([activeCommunity, hash]) => {
      this.loadRecord(activeCommunity.communityId, activeCommunity.data.community_id)
      .then(() => {
        this.setState({
          communityId: activeCommunity.communityId,
          communityRecordId: activeCommunity.data.community_id,
          communityGuid: activeCommunity.data.community_guid,
          configurations: this.props.data,
        })
      })
    })
  }

  public render() {
    return (
      <div className="survey-results-design">
      {this.state.isLoading ? <Loading size="64" /> :
      <div className="survey-results-container">
        <div className="preview">
          <div className="survey-results-body"
               style={{backgroundColor: '#FFFFFF', margin: '0px'}}>
              <PreviewComponent configurations={this.props.data} data={this.props.data} select={this.state.selected} />
          </div>
        </div>
        <div className="settings">
          <div className="designbuttonwrap">
            <div className={this.buttonClassNames(this.isDirty)}
                  onClick={() => this.saveRecord(this.state.communityRecordId)}>
              Save
            </div>
          </div>
          <div className="editor">
            {this.getEditor()}
          </div>
        </div>
        <div className="menu">
          <PreviewWidgetMenuComponent
            selectItem={this.selectItem}
            saveRecord={this.saveRecord}
            isDirty={this.isDirty} menuSections={MenuSections}>
          </PreviewWidgetMenuComponent>
        </div>
      </div>
      }
    </div>
    )
  }
  private buttonClassNames = (enabled: boolean): string => {
    return enabled ? 'save-button save-button-enabled clickable-item' :
                     'save-button save-button-disabled'
  }
  private selectItem = (item: MenuSection) => {
    this.setState({
      selected: item,
    })
  }
  private getEditor = () => {
    if (this.state.selected) {
      switch (this.state.selected.value) {
        case MenuItems.headerAndLogo:
          return <HeaderSettings data={this.props.data}
                    name={MenuItems.headerAndLogo}
                    onChange={(field: string, value: string) => this.propertyChanged(field, value)}/>
        case MenuItems.appearance:
          return <AppearanceSettings data={this.props.data}
                    name={MenuItems.appearance}
                    onChange={(field: string, value: string) => this.propertyChanged(field, value)}/>
        case MenuItems.results:
          return <ResultsSettings data={this.props.data}
                    name={MenuItems.results}
                    onChange={(field: string, value: string) => this.propertyChanged(field, value)}/>
        case MenuItems.preview:
          return <PreviewSettings data={this.props.data}
                    name={MenuItems.preview}
                    onChange={(field: string, value: string) => this.propertyChanged(field, value)}/>
      }
    } else {
      return <HeaderSettings data={this.props.data}
                name="header and logo"
                onChange={(field: string, value: string) => this.propertyChanged(field, value)}/>
    }
    return <div>No Editor Found</div>
  }

}

export const WidgetsSurveyResults = GenericRedux.createConnect(WidgetsSurveyResultsComponent, REDUX_STORE_HOME)
injectReducer(
  REDUX_STORE_HOME,
  Redux.combineReducers({
    data: GenericRedux.createGenericReducer(REDUX_STORE_HOME, {}),
  }),
)